<template>
  <div class="row">
      <div class="col-12">
          <div class="row">
              <div class="col-sm-12">
                  <div class="card">
                      <div class="card-body">
                          <div class="card-header-2">
                              <h5>Product Information</h5>
                          </div>

                          <v-form class="theme-form theme-form-2 mega-form" ref="formProduct" >
                              <div class="row">
                                  <div class="mb-4 row align-items-center">
                                      <label class="form-label-title col-sm-2 mb-0">Name</label>
                                      <div class="col-sm-10">
                                          <v-card>
                                              <v-tabs v-model="tabLanguageName" color="deep-purple-accent-4">
                                                  <v-tab value="nameEn">Ingles</v-tab>
                                                  <v-tab value="nameEs">Español</v-tab>
                                                  <v-tab value="nameFr">Frances</v-tab>
                                              </v-tabs>
                                              <v-window v-model="tabLanguageName">
                                                  <v-text-field v-if="tabLanguageName === 'nameEn'"
                                                      placeholder="Name ingles" v-model="nameEn" :rules="[(v) => !!v || 'Item is required']"> </v-text-field>
                                                  <v-text-field v-if="tabLanguageName === 'nameEs'"
                                                      placeholder="Nombre español" v-model="nameEs" :rules="[(v) => !!v || 'Item is required']"> </v-text-field>
                                                  <v-text-field v-if="tabLanguageName === 'nameFr'"
                                                      placeholder="Nom français" v-model="nameFr" :rules="[(v) => !!v || 'Item is required']"> </v-text-field>
                                              </v-window>
                                          </v-card>
                                      </div>
                                  </div>
                              </div>

                              <div class="row">
                                  <div class="col-12">
                                      <div class="row">
                                          <label class="form-label-title col-sm-2 mb-0">Description</label>
                                          <div class="col-sm-10">
                                              <v-card>
                                                  <v-tabs v-model="tabLanguageEditor" color="deep-purple-accent-4">
                                                      <v-tab value="editorDataEn">Ingles</v-tab>
                                                      <v-tab value="editorDataEs">Español</v-tab>
                                                      <v-tab value="editorDataFr">Frances</v-tab>
                                                  </v-tabs>
                                                  <v-window v-model="tabLanguageEditor">
                                                      <div id="editor">
                                                          <ckeditor v-if="tabLanguageEditor === 'editorDataEn'"
                                                              id="snippet-classic-editor-en"
                                                              :editor="editor"
                                                              v-model="editorDataEn"
                                                              :config="editorConfig"
                                                          ></ckeditor>
                                                          <ckeditor v-else-if="tabLanguageEditor === 'editorDataEs'"
                                                              id="snippet-classic-editor-es"
                                                              :editor="editor"
                                                              v-model="editorDataEs"
                                                              :config="editorConfig"
                                                          ></ckeditor>
                                                          <ckeditor v-else-if="tabLanguageEditor === 'editorDataFr'"
                                                              id="snippet-classic-editor-fr"
                                                              :editor="editor"
                                                              v-model="editorDataFr"
                                                              :config="editorConfig"
                                                          ></ckeditor>
                                                      </div>
                                                  </v-window>
                                              </v-card>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                               <br /><br />
                                <!--  
                              <div class="row">
                                  <div class="col-12">
                                      <div class="mb-4 row align-items-center">
                                          <label class="col-sm-2 col-form-label form-label-title">New Image</label>
                                          <div class="col-sm-10">
                                              <v-file-input v-model="newImage" counter placeholder="Select your image" />
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-12">
                                      <div class="mb-4 row align-items-center">
                                          <label class="col-sm-2 col-form-label form-label-title">Image</label>
                                          <div class="col-sm-10">
                                              <v-img :src="srcImage"></v-img>
                                          </div>
                                      </div>
                                  </div>
                              </div> -->
                              
                              <div class="row">
                                  <div class="mb-4 row align-items-center">
                                      <label class="form-label-title col-sm-2 mb-0">Sale price</label>
                                      <div class="col-sm-10">
                                          <v-text-field placeholder="Sale price" v-model="salePrice" type="number"></v-text-field>
                                      </div>
                                  </div>
                              </div>
                             
                              <div class="row">
                                  <div class="mb-4 row align-items-center">
                                      <label class="form-label-title col-sm-2 mb-0">Discount</label>
                                      <div class="col-sm-10">
                                          <v-text-field placeholder="Discount" v-model="discount" type="number"></v-text-field>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="mb-4 row align-items-center">
                                      <label class="form-label-title col-sm-2 mb-0">Offer price</label>
                                      <div class="col-sm-10">
                                          <v-text-field placeholder="Offer price" v-model="offerPrice" type="number"></v-text-field>
                                      </div>
                                  </div>
                              </div>
                              <v-expansion-panels >
                                  <v-expansion-panel title="Categorys" color="deep-purple-accent-4">
                                      <v-expansion-panel-text>
                                          <div class="row">
                                              <div class="mb-4 row align-items-center">
                                                  <label class="form-label-title col-sm-2 mb-0">Category</label>
                                                  <div class="col-sm-10" >
                                                      <!--  v-model:selected="selectedTreeCategoryData"
                                                              selectable - mas de uno

                                                              v-model:activated="selectedTreeCategoryData"
                                                              @update:active="getActiveCategoryValue"

                                                              
                                                              
                                                          
                                                              item-text="name" 
                                                      -->
                                                          <!-- name es JSON {es,en,fr}: título formateado -->
                                                          <v-treeview style="max-height:33rem;" class="border"
                                                              :items="treeCategoryData"
                                                              :item-title="(item) => getMultilangText(item.name)"
                                                              item-value="id"
                                                              v-model:activated="selectedTreeCategoryData"
                                                              @update:active="getActiveCategoryValue"
                                                              :open="openedCategoryFather"
                                                              activatable
                                                              open-all
                                                          ></v-treeview>
                                                          <br></br>
                                                          <label class="form-label-title col-sm-10 mb-0">
                                                              Category selected: {{ getSelectedCategoryParents() }}
                                                          </label>
                                                  </div>
                                                                                  
                                              </div>
                                          </div>
                                      </v-expansion-panel-text>
                                  </v-expansion-panel>
                              </v-expansion-panels>
                              
                              <v-expansion-panels v-if="false">
                                  <v-expansion-panel title="Multimedia (AutoSave Order)" color="deep-purple-accent-4">
                                      <v-expansion-panel-text>
                                          <div class="dropzone d-flex flex-wrap flex-row h-80 overflow-y-auto gap-2 p-2" style="height: 33rem;" @dragover="dragOver" @dragleave="dragLeave" @drop="drop">
                                              <input class="d-none" type="file" ref="fileInput" id="fileInput" @change="handleFileInput" accept="image/*" multiple>
                                              <!-- <label for="fileInput" class="file-input-button flex justify-center items-center text-center text-sm cursor-pointer border shadow text-slate-400 p-3 h-[48%] w-[48%]"> -->
                                              <label for="fileInput" class="theme-form image-preview cursor-pointer border shadow overflow-hidden flex flex-col justify-center h-full">
                                                  <div class="flex flex-col items-center">
                                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                                                      </svg>
                                                      <div class="text-center">
                                                          Arrastrar o seleccionar imágenes
                                                      </div>
                                                  </div>
                                              </label>
                                              <!-- <template v-for="(file, index) in files" :key="index">
                                                  <div class="image-preview border overflow-hidden">
                                                      <div class="border flex items-center h-full overflow-hidden">
                                                          <img :src="file.url" :alt="file.name" class="object-fit-cover" style="width: 100%;">
                                                      </div>
                                                      
                                                  </div>
                                              </template> -->                                        
                                      
                                              <template v-for="(file, index) in multimedia" :key="index">
                                                  <div class="image-preview border overflow-hidden">
                                                      <div class="position-relative border flex items-center h-full overflow-hidden">
                                                          <button v-if="index === 0"  type="button" class="buttons-image-dropzone isMainImage-button">
                                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                  <path d="M5.52 19c.64-2.2 1.84-3 3.22-3h6.52c1.38 0 2.58.8 3.22 3"/>
                                                                  <circle cx="12" cy="10" r="3"/><circle cx="12" cy="12" r="10"/>
                                                              </svg> 
                                                          </button>
                                                          <button v-if="index === 1"  type="button" class="buttons-image-dropzone isBackImage-button">
                                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle>
                                                                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                                              </svg>
                                                          </button>
                                                          <button v-on:click="deleteThisImage(index, file.id)" type="button" class="buttons-image-dropzone delete-button">
                                                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                                                                  <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                                              </svg>
                                                          </button>
                                                          <button v-on:click="moveImage(index, file.id, 'left')" type="button" class="buttons-image-dropzone left-button">
                                                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                                  <path stroke-linecap="round" stroke-linejoin="round" d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5" />
                                                              </svg>
                                                          </button>
                                                          <button v-on:click="moveImage(index, file.id, 'right')" type="button" class="buttons-image-dropzone right-button">
                                                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                                  <path stroke-linecap="round" stroke-linejoin="round" d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" />
                                                              </svg>
                                                          </button>
                                                          <button v-on:click="openDialogUpdateImageProperties(file)" type="button" class="buttons-image-dropzone edit-image-button">
                                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                  <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"></path>
                                                                  <polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon>
                                                              </svg>
                                                              
                                                          </button>
                                                                                                                      
                                                          <v-dialog v-model="dialogUpdateImageProperties" max-width="900px">
                      
                                                              <v-card title="Update image properties">
                                                              
                                                                  <v-form ref="formUpdateImageProperties">
                                                                      <br></br>
                                                                      <div style="display:inline;" class="row col-12">
                                                                          
                                                                          <div class="row">
                                                                              <div class="mb-4 row align-items-center">
                                                                                  <div class="row">
                                                                                      <div class="col-sm-2">
                                                                                          <label class="form-label-title mb-0">Image with color? </label>
                                                                                      </div>
                                                                                      <div class="col-sm-3 ">
                                                                                          <v-checkbox v-model="enabledColorImageProperties"></v-checkbox>
                                                                                      </div>      
                                                                                      <div class="col-sm-7 form-label-title  mb-0"> 
                                                                                          <v-combobox v-if="enabledColorImageProperties"
                                                                                              label="Search color..."
                                                                                              :items="dataColorCombo"
                                                                                              item-title="name"
                                                                                              item-value="id"
                                                                                              v-model="updateColorImageProperties"
                                                                                              variant="outlined"
                                                                                          ></v-combobox>
                                                                                      </div>
                                                                                  </div>
                                                                              </div>    
                                                                          </div>
                                                                                   
                                                                          <div class="row">
                                                                              <div class="mb-4 row align-items-center">
                                                                                  <label class="form-label-title col-sm-2 mb-0">Alt image (SEO)</label>
                                                                                  <div class="col-sm-10">
                                                                                      <v-text-field placeholder="Alt image" type="text" v-model="updateAltImageProperties" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                                                                  </div>
                                                                              </div>
                                                                          </div>
                                                                          
                                                                      </div>
                                                                  </v-form>

                                                                  <v-card-actions>
                                                                      <v-spacer></v-spacer>
                                                                      <v-btn
                                                                          text="Cancel"
                                                                          variant="text"
                                                                          @click="dialogUpdateImageProperties = false"
                                                                      ></v-btn>

                                                                      <v-btn
                                                                          color="green"
                                                                          text="Update"
                                                                          variant="flat"
                                                                          @click="validateUpdateImageProperties"
                                                                      ></v-btn>
                                                                  </v-card-actions>
                                                              </v-card>
                                                          </v-dialog>


                                                          <img :src="file.codi && file.codi === 'codificada' ? file.url : apiBase+'/assets/multimedia/'+file.name" alt="Imagen del producto" class="object-fit-cover" style="width: 100%;">
                                                          
                                                      </div>
                                                      <!-- <span class="image-name text-xs">{{ file.name }}</span> -->
                                                  </div>
                                              </template>
                                          </div>
                                      </v-expansion-panel-text>
                                  </v-expansion-panel>
                              </v-expansion-panels>

                              <v-expansion-panels v-if="false">
                                  <v-expansion-panel title="Inventory" color="deep-purple-accent-4">
                                      <v-expansion-panel-text>
                                          <v-form class="theme-form theme-form-2 mega-form" ref="formAddInventoryProduct" >
                                              <br></br>
                                              <div class="row">
                                                  <div class="mb-4 row align-items-center">
                                                      <label class="form-label-title col-sm-2 mb-0">Vendor</label>
                                                      <div class="col-sm-10">
                                                          <v-combobox
                                                              label="Search vendor..."
                                                              :items="dataVendorCombo"
                                                              item-title="name"
                                                              item-value="id"
                                                              v-model="vendorInventory"
                                                              variant="outlined"
                                                          ></v-combobox>
                                                      </div>
                                                  </div>
                                              </div>

                                              <div class="row">
                                                  <div class="mb-6 row align-items-center">
                                                      <div class="row">
                                                          <div class="col-sm-2">
                                                              <label class="form-label-title mb-0">Product with colors? </label>
                                                          </div>
                                                          <div class="col-sm-3 ">
                                                              <v-checkbox v-model="enabledColorInventory"></v-checkbox>
                                                          </div>      
                                                          <div class="col-sm-6 form-label-title  mb-0"> 
                                                              <v-combobox v-if="enabledColorInventory"
                                                                  label="Search color..."
                                                                  :items="dataColorCombo"
                                                                  item-title="name"
                                                                  item-value="id"
                                                                  v-model="colorInventory"
                                                                  variant="outlined"
                                                              ></v-combobox>
                                                          </div>
                                                          <div class="col-sm-1 form-label-title mb-0" v-if="enabledColorInventory"
                                                              :style="{ 
                                                                  backgroundColor: selectedColorHex, 
                                                                  height: '55px', /* Alto del cuadrado */
                                                                  border: '2px solid #000', /* Borde negro */
                                                                  borderRadius: '5px', /* Esquinas ligeramente redondeadas */
                                                                  display: 'flex', /* Centrar el texto dentro del div */
                                                                  alignItems: 'center', /* Centrar verticalmente */
                                                                  justifyContent: 'center' /* Centrar horizontalmente */
                                                              }"> 
                                                              <span>{{ selectedColorHex }}</span>
                                                          </div>
                                                      </div>
                                                  </div>    
                                              </div>
                                              
                                              <div class="row">
                                                  <div class=" mb-4 row align-items-center">
                                                      <div class="row">
                                                          <div class="col-sm-2">
                                                              <label class="form-label-title ">Product with sizes? </label>
                                                          </div>
                                                          <div class="col-sm-3 ">
                                                              <v-checkbox v-model="enabledSizeInventory"></v-checkbox>
                                                          </div>      
                                                          <div class="col-sm-7 form-label-title  mb-0">
                                                              <v-radio-group inline label="Sizes" v-if="enabledSizeInventory">
                                                                  <v-radio v-for="(size, index) in dataSizeCombo" :key="index" :label="'[' + size.code + '] ' + size.name" :value="size.id" v-model="sizeInventory"></v-radio>
                                                              </v-radio-group>
                                                          </div>    
                                                      </div>
                                                  </div>    
                                              </div>
                                                                                              
                                              <div class="row">
                                                  <div class="mb-4 row align-items-center">
                                                      <label class="form-label-title col-sm-2 mb-0">Quantity</label>
                                                      <div class="col-sm-10">
                                                          <v-text-field placeholder="Quantity" type="number" v-model="quantityInventory" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="row">
                                                  <div class="mb-4 row align-items-center">
                                                      <label class="form-label-title col-sm-2 mb-0">Stock</label>
                                                      <div class="col-sm-10">
                                                          <v-text-field placeholder="Available stock" type="number" v-model="stockInventory"></v-text-field>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="row">
                                                  <div class="mb-4 row align-items-center">
                                                      <label class="form-label-title col-sm-2 mb-0">Description</label>
                                                      <div class="col-sm-10">
                                                          <v-text-field class="form-label" placeholder="Description inventory" v-model="descriptionInventory"></v-text-field>
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="d-flex flex-column">
                                                  <v-btn class="mt-4" color="success" block @click="validateAddInventoryProduct"> Add inventory </v-btn>
                                              </div>
                                              <v-alert v-if="messageErrorInventory != ''" :type="typeOfMessageInventory" :text="messageErrorInventory"></v-alert>
                                          </v-form>
                                          <br></br>
                                          <div class="row">
                                              <div class="col-sm-12">
                                                  <div class="card">
                                                      <div class="card-body">
                                                          <div class="table-responsive table-desi table-product">
                                                              <v-data-table-server
                                                                  class="table table-1d all-package"
                                                                  v-model:items-per-page="itemsPerPage"
                                                                  :search="searchInventoryProductGrid"
                                                                  :headers="showHeaders"
                                                                  :items-length="pagination.total"
                                                                  :items="dataInventoryProductGrid"
                                                                  :loading="loading"
                                                                  item-value="name"
                                                                  @update:options="getInventoryProductGrid"
                                                              >
                                                                  <template v-slot:thead>
                                                                      <tbody>
                                                                          <tr>
                                                                              <td v-if="selectedHeaders.includes('vendor_name')">
                                                                                  <v-combobox
                                                                                      label="Search vendor..."
                                                                                      :items="dataVendorCombo"
                                                                                      item-title="name"
                                                                                      item-value="id"
                                                                                      v-model="filterVendorGridInventory"
                                                                                  ></v-combobox>
                                                                              </td> 
                                                                              <td v-if="selectedHeaders.includes('color_name')">
                                                                                  <v-combobox
                                                                                      label="Search color..."
                                                                                      :items="dataColorCombo"
                                                                                      item-title="name"
                                                                                      item-value="id"
                                                                                      v-model="filterColorGridInventory"
                                                                                  ></v-combobox>
                                                                              </td> 
                                                                              <td v-if="selectedHeaders.includes('size_name')">
                                                                                  <v-combobox
                                                                                      label="Search size..."
                                                                                      :items="dataSizeCombo"
                                                                                      item-title="name"
                                                                                      item-value="id"
                                                                                      v-model="filterSizeGridInventory"
                                                                                  ></v-combobox>
                                                                              </td>                                                                                 
                                                                              <td v-if="selectedHeaders.includes('quantity')">
                                                                                  <v-text-field v-model="filterQuantityGridInventory" hide-details placeholder="Search quantity..." class="ma-2" density="compact"></v-text-field>
                                                                              </td>
                                                                              <td v-if="selectedHeaders.includes('stock')">
                                                                                  <v-text-field v-model="filterStockGridInventory" hide-details placeholder="Search stock..." class="ma-2" density="compact"></v-text-field>
                                                                              </td>
                                                                              <td v-if="selectedHeaders.includes('description')">
                                                                                  <v-text-field v-model="filterDescriptionGridInventory" hide-details placeholder="Search description..." class="ma-2" density="compact"></v-text-field>
                                                                              </td>

                                                                              <td v-if="selectedHeaders.includes('actions')"></td>
                                                                          </tr>
                                                                      </tbody>
                                                                  </template>

                                                                  <!-- <template v-slot:item.image="{ item }">
                                                                      <v-card class="my-2 v-responsive v-img rounded">
                                                                          <v-img :src="`${item.multimedia[0].path}${item.multimedia[0].name}`"></v-img>
                                                                      </v-card>
                                                                  </template>
                                                                  
                                                                  <template v-slot:item.active="{ item }">
                                                                      <v-checkbox class="ma-2"
                                                                          v-model="item.active"
                                                                          readonly
                                                                      ></v-checkbox>
                                                                  </template> -->
                                                                  <template v-slot:item.actions="{ item }">
                                                                      <v-btn color="primary" class="elevation-0" icon variant="plain" @click="openDialogUpdateGridInventory(item)"> <v-icon> mdi-pencil-outline </v-icon> </v-btn>
                                           
                                                                      <v-dialog v-model="dialogEditGridInventory" max-width="1000px">
                                  
                                                                          <v-card title="Update inventory">
                                                                          
                                                                              <v-form ref="formUpdateProductInventory">
                                                                                  <br></br>
                                                                                  <div style="display:inline;" class="row col-12">
                                                                                      <div class="row">
                                                                                          <div class="mb-4 row align-items-center">
                                                                                              <label class="form-label-title col-sm-2 mb-0">Vendor</label>
                                                                                              <div class="col-sm-10">
                                                                                                  <v-combobox
                                                                                                      label="Search vendor..."
                                                                                                      :items="dataVendorCombo"
                                                                                                      item-title="name"
                                                                                                      item-value="id"
                                                                                                      v-model="updateVendorArticleInventory"
                                                                                                      variant="outlined"
                                                                                                  ></v-combobox>
                                                                                              </div>
                                                                                          </div>
                                                                                      </div>
                                                                                      
                                                                                      <div class="row" v-if="updateColorArticleInventory != ''">
                                                                                          <div class="mb-4 row align-items-center">
                                                                                              
                                                                                              <div class="col-sm-2">
                                                                                                  <label class="form-label-title mb-0">Color </label>
                                                                                              </div>
                                                                                              <div class="col-sm-9 form-label-title  mb-0"> 
                                                                                                  <v-combobox
                                                                                                      label="Search color..."
                                                                                                      :items="dataColorCombo"
                                                                                                      item-title="name"
                                                                                                      item-value="id"
                                                                                                      v-model="updateColorArticleInventory"
                                                                                                      variant="outlined"
                                                                                                  ></v-combobox>
                                                                                              </div>
                                                                                              <div class="col-sm-1 form-label-title mb-0" 
                                                                                                  :style="{ 
                                                                                                          backgroundColor: selectedColorUpdateColorArticleHex, 
                                                                                                          top: '-12px',
                                                                                                          height: '55px', /* Alto del cuadrado */
                                                                                                          border: '2px solid #000', /* Borde negro */
                                                                                                          borderRadius: '5px', /* Esquinas ligeramente redondeadas */
                                                                                                          display: 'flex', /* Centrar el texto dentro del div */
                                                                                                          alignItems: 'center', /* Centrar verticalmente */
                                                                                                          justifyContent: 'center' /* Centrar horizontalmente */
                                                                                                      }"> 
                                                                                                  <span>{{ selectedColorUpdateColorArticleHex }}</span>
                                                                                              </div>
                                                                                              
                                                                                          </div>    
                                                                                      </div>
                                                                                      
                                                                                      <div class="row" v-if="updateSizeArticleInventory != ''" >
                                                                                          <div class=" mb-4 row align-items-center">
                                                                                              
                                                                                              <div class="col-sm-2">
                                                                                                  <label class="form-label-title ">Size </label>
                                                                                              </div>
                                                                                              <div class="col-sm-10 form-label-title  mb-0">
                                                                                                  <v-combobox
                                                                                                      label="Search color..."
                                                                                                      :items="dataSizeCombo"
                                                                                                      item-title="name"
                                                                                                      item-value="id"
                                                                                                      v-model="updateSizeArticleInventory"
                                                                                                      variant="outlined"
                                                                                                  ></v-combobox>
                                                                                              </div>    
                                                                                              
                                                                                          </div>    
                                                                                      </div>
                                                                                                                                      
                                                                                      <div class="row">
                                                                                          <div class="mb-4 row align-items-center">
                                                                                              <label class="form-label-title col-sm-2 mb-0">Quantity</label>
                                                                                              <div class="col-sm-10">
                                                                                                  <v-text-field placeholder="Quantity" type="number" v-model="updateQuantityArticleInventory" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                                                                              </div>
                                                                                          </div>
                                                                                      </div>
                                                                                      <div class="row">
                                                                                          <div class="mb-4 row align-items-center">
                                                                                              <label class="form-label-title col-sm-2 mb-0">Stock</label>
                                                                                              <div class="col-sm-10">
                                                                                                  <v-text-field placeholder="Available stock" type="number" v-model="updateStockArticleInventory" :rules="[(v) => !!v || 'Item is required']"></v-text-field>
                                                                                              </div>
                                                                                          </div>
                                                                                      </div>
                                                                                      <div class="row">
                                                                                          <div class="mb-4 row align-items-center">
                                                                                              <label class="form-label-title col-sm-2 mb-0">Description</label>
                                                                                              <div class="col-sm-10">
                                                                                                  <v-text-field placeholder="Description inventory" v-model="updateDescriptionArticleInventory"></v-text-field>
                                                                                              </div>
                                                                                          </div>
                                                                                      </div>
                                                                                  </div>
                                                                              </v-form>

                                                                              <v-card-actions>
                                                                                  <v-spacer></v-spacer>

                                                                                  <v-btn
                                                                                      text="Cancel"
                                                                                      variant="text"
                                                                                      @click="dialogEditGridInventory = false"
                                                                                  ></v-btn>
                                                                                  <v-btn
                                                                                      color="green"
                                                                                      text="Update"
                                                                                      variant="flat"
                                                                                      @click="validateUpdateProductInventory"
                                                                                      
                                                                                  ></v-btn>
                                                                              </v-card-actions>
                                                                          </v-card>
                                                                          
                                                                      </v-dialog>


                                                                      <v-btn color="error"   class="elevation-0" icon variant="plain" @click="openDialogDeleteGridInventory(item)"><v-icon> mdi-trash-can-outline </v-icon> </v-btn>
                                          
                                                                      <v-dialog v-model="dialogDeleteGridInventory" max-width="600px">
                                                                          <v-card>
                                                                              <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                                                                              <v-card-text>  Are you sure you want to delete the inventory with the stock '{{ itemInventoryToDelete?.stock ?? "N/A" }}'? </v-card-text>
                                                                              <v-card-actions>
                                                                                  <v-btn color="red"   text @click="dialogDeleteGridInventory = false">Cancel</v-btn>
                                                                                  <v-btn color="green" text @click="deleteProductInventory()">Delete</v-btn>
                                                                              </v-card-actions>
                                                                          </v-card>
                                                                      </v-dialog>
                                                                  </template>
                                                              </v-data-table-server>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>

                                      </v-expansion-panel-text>
                                  </v-expansion-panel>
                              </v-expansion-panels>
                              
                              <div class="row">
                                  <div class="col-12 blogGrid">
                                      <div class="mb-4 row align-items-center">
                                          <label class="col-sm-2 col-form-label form-label-title">Is new</label>
                                          <div class="col-sm-10">
                                              <v-checkbox v-model="isNew" label="Is new"></v-checkbox>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <div class="row">
                                  <div class="col-12">
                                      <div class="mb-4 row align-items-center">
                                          <label class="col-sm-2 col-form-label form-label-title">Active</label>
                                          <div class="col-sm-10">
                                              <v-checkbox v-model="active" label="Active"></v-checkbox>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                          
                              <div class="d-flex flex-column">
                                  <v-btn class="mt-4" color="success" block @click="validate"> Create </v-btn>
                              </div>
                          </v-form>
                      </div>

                      <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import axios from 'axios'
import { getMultilangText } from '@/services/multilangText'
import { ref, onMounted } from 'vue'
import { mapGetters } from 'vuex'
import _ from 'lodash';

 
export default {
  name: 'app',
  title: 'Edit Product',
  data() {
      return {
          apiBase: process.env.VUE_APP_URL_API_BASE,
          id: null,
          author: null,
          
          tabLanguageName: null,
          nameEn: '',
          nameEs: '',
          nameFr: '',

          tabLanguageEditor: null,
          editorDataEn: '',
          editorDataEs: '',
          editorDataFr: '',

          salePrice: '',
          discount: '',
          offerPrice: '',

          editor: ClassicEditor,
          editorConfig: {
              toolbar: {
                  items: ['undo', 'redo', '|', 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote']
              },
              language: 'es'
          },
          newImage: [],
          srcImage: null,
          altImage: null,

          //INVENTARIO

          enabledColorInventory: false,
          enabledSizeInventory: false,
          dataColorCombo: [],
          colorInventory: '',
          dataSizeCombo: [], 
          sizeInventory: '',
          dataVendorCombo: [],
          vendorInventory: '',
          quantityInventory: '',
          stockInventory: '',
          descriptionInventory: '',


          //INVENTARIO GRID
          dataInventoryProductGrid: ref([]),
          pagination: ref({
              from: 0,
              to: 0,
              total: 0,
              current: 1,
              lastPage: 0
          }),
          itemsPerPage: 10,

          selectedHeaders: ['vendor_name', 'color_name', 'size_name' ,'quantity', 'stock', 'description', 'actions'],
          headers: [
              {
                  title: 'ID',
                  align: 'start',
                  sortable: true,
                  key: 'id'
              },
               {
                  title: 'Vendor',
                  align: 'center',
                  sortable: true,
                  key: 'vendor_name',
                  value: 'vendor_name'
              }, 
              {
                  title: 'Color',
                  align: 'center',
                  sortable: true,
                  key: 'color_name',
                  value: 'color_name'
              },
              {
                  title: 'Size',
                  align: 'center',
                  sortable: true,
                  key: 'size_name',
                  value: 'size_name'
              },
              {
                  title: 'Quantity',
                  align: 'center',
                  sortable: true,
                  key: 'quantity',
                  value: 'quantity'
              },
              {
                  title: 'Stock',
                  align: 'center',
                  sortable: true,
                  key: 'stock',
                  value: 'stock'
              },
              {
                  title: 'Description',
                  align: 'center',
                  sortable: true,
                  key: 'description',
                  value: 'description'
              },
              {
                  title: 'Actions',
                  align: 'center',
                  sortable: false,
                  key: 'actions'
              }
          ],
          loading: true,

          // Edicion de imagenes
          dialogUpdateImageProperties: false,

          updateIdImageProperties: '',
          enabledColorImageProperties: false,
          updateColorImageProperties: '',
          updateAltImageProperties  : '',

          // Filtros grid inventory - search
          searchInventoryProductGrid: '',
          idGridInventory: '',
          filterVendorGridInventory: '',
          filterColorGridInventory: '',
          filterSizeGridInventory: '',
          filterQuantityGridInventory: '',
          filterStockGridInventory: '',
          filterDescriptionGridInventory: '',

          // Update/Delete Inventario
          dialogDeleteGridInventory: false,
          dialogEditGridInventory: false,

          updateIdInventoryArticleInventory: '',
          updateArticlecolorsizeidArticleInventory: '',
          updateVendorArticleInventory: '',
          updateColorArticleInventory: '',
          updateSizeArticleInventory: '',
          updateQuantityArticleInventory: '',
          updateStockArticleInventory: '',
          updateDescriptionArticleInventory: '',

          itemInventoryToDelete: null,

          // Categoria
          selectedTreeCategoryData  : [], 
          treeCategoryData : [],   
          openedCategoryFather: [0,1],
                     
          isNew: false,
          active: false,

          messageErrorInventory: '',
          typeOfMessageInventory: '',

          messageError: '',
          typeOfMessage: '',

          // Dropzone 
          files: [],
          multimedia: [
              /* {
                  id: "",
                  name: ""
              } */
          ],
          selectedImages: [],
      }
  },
  watch: {
      loading() {

      },
      editorData() {
      },
      newImage() {
      },
      quantityInventory(value) {
          this.stockInventory = value;
      },
      discount(value) {
          // Asegurarse de que salePrice y value tengan valores
          if (this.salePrice !== '' && value !== '') {
              // Convertir salePrice a número si es un string
              const salePrice = parseFloat(this.salePrice);
              // Calcular el precio con descuento
              this.offerPrice = salePrice * (1 - value / 100);
          }
      },
      id() {
          this.search = String(Date.now())
      },
      filterVendorGridInventory() {
          this.searchInventoryProductGrid = String(Date.now())
      },
      filterColorGridInventory() {
          this.searchInventoryProductGrid = String(Date.now())
      },
      filterSizeGridInventory() {
          this.searchInventoryProductGrid = String(Date.now())
      },
      filterQuantityGridInventory() {
          this.searchInventoryProductGrid = String(Date.now())
      },
      filterStockGridInventory() {
          this.searchInventoryProductGrid = String(Date.now())
      },
      filterDescriptionGridInventory() {
          this.searchInventoryProductGrid = String(Date.now())
      },
      
  },
  computed: {
      //Done to get the ordered headers
      showHeaders() {
          return this.headers.filter((s) => this.selectedHeaders.includes(s.key))
      },
      ...mapGetters({
          getUser: 'getUser'
      }),  
      selectedColorHex() {
          // Encuentra el color seleccionado en la lista de colores
          const selectedColorHex = this.dataColorCombo.find(color => color === this.colorInventory);
          // Retorna el código hexadecimal si se encuentra, de lo contrario, retorna un string vacío
          return selectedColorHex ? selectedColorHex.hexadecimalCode : '';
      },  
      selectedColorUpdateColorArticleHex() {
          // Encuentra el color seleccionado en la lista de colores
          const selectedColorUpdateColorArticleHex = this.dataColorCombo.find(color => color.id === this.updateColorArticleInventory.id);
          
          // Retorna el código hexadecimal si se encuentra, de lo contrario, retorna un string vacío
          return selectedColorUpdateColorArticleHex ? selectedColorUpdateColorArticleHex.hexadecimalCode : '';
      }

  },
  methods: {
      getMultilangText,
      getActiveCategoryValue(value){
          this.selectedTreeCategoryData = value
          this.getSelectedCategoryParents()
      }, 
      async validate() {
          const { valid } = await this.$refs.formProduct.validate()

          if (valid) {
              this.createProduct()
          } else {
              alert('Faltan parametros')
          }
      },
      async validateAddInventoryProduct() {
          const { valid } = await this.$refs.formAddInventoryProduct.validate()

          if (valid) {
              this.addInventoryProduct()
          } else {
              alert('Faltan parametros')
          }
      },
      async validateUpdateProductInventory() {
          const { valid } = await this.$refs.formUpdateProductInventory.validate()

          if (valid) {
              this.updateProductInventory()
          } else {
              alert('Faltan parametros')
          } 
      },
      async validateUpdateImageProperties() {
          //Error en formUpdateImageProperties -> coge mas de un valor this.$refs.formUpdateImageProperties[0]
          /* const { valid } = await this.$refs.formUpdateImageProperties.validate()

          if (valid) {
              this.updateImageProperties()
          } else {
              alert('Faltan parametros')
          } */
          this.updateImageProperties()
      },
      resetValidation() {
          this.$refs.form.resetValidation()
      },
      getListCategory() {
          let self = this

          let apiURL = process.env.VUE_APP_URL_API_BASE + '/category/list'

          return new Promise(async (resolve, reject) => {
              let status = 'Success'
              await axios({
                  url: apiURL,
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  data: {},
                  responseType: 'json'
              }).then((response) => {
                  if (response.data) {
                      
                      self.treeCategoryData = this.buildTreeCategory(response.data);
                     
                      this.openedCategoryFather = [0,1]
                      status = 'Success'
                  }
              })
              resolve(status)
          })
      },
      buildTreeCategory(categories, parentId = null) {
          const tree = [];
          categories.filter(category => category.categoryFather === parentId).forEach(category => {
              const children = this.buildTreeCategory(categories, category.id);
              if (children.length) {
                  category.children = children;
              }
              tree.push(category);
              //this.toggleCategory(category)
          });
          
          return tree;
      }, 
      toggleCategory(category) {
          const index = this.openedCategoryFather.indexOf(category.id);
          if (index === -1) {
              this.openedCategoryFather.push(category.id);
          } else {
              this.openedCategoryFather.splice(index, 1);
          }
          this.openedCategoryFather = [0,1]
      },
      getSelectedCategoryParents() {
          if (this.treeCategoryData && this.selectedTreeCategoryData.length > 0) {
              const selectedCategoryId = this.selectedTreeCategoryData[0];

              // Función recursiva para buscar una categoría por su ID
              const findCategoryById = (categories, id) => {
              for (let category of categories) {
                  if (category.id === id) {
                  return category;
                  }
                  if (category.children && category.children.length > 0) {
                  const result = findCategoryById(category.children, id);
                  if (result) {
                      return result;
                  }
                  }
              }
              return null;
              };

              // Función para encontrar todos los padres de una categoría
              const findParents = (categories, id) => {
              let category = findCategoryById(categories, id);
              if (!category) {
                  return [];
              }

              const parents = [];

              while (category && category.categoryFather !== null) {
                  category = findCategoryById(categories, category.categoryFather);
                  if (category) {
                  parents.unshift(category);
                  }
              }

              return parents;
              };

              // Obtener los padres de la categoría seleccionada
              const parents = findParents(this.treeCategoryData, selectedCategoryId);

              // Buscar la categoría seleccionada para obtener su nombre
              const selectedCategory = findCategoryById(this.treeCategoryData, selectedCategoryId);

              // Concatenar los nombres de los padres y el nombre de la categoría seleccionada
              if (selectedCategory) {
                  const hierarchy = [...parents.map(parent => getMultilangText(parent.name)), getMultilangText(selectedCategory.name)].join(' > ');
                  return hierarchy;
              } else {
                  return "N/A";
              }
          }
          return "N/A";
      },
      getListColor() {
          let self = this

          let apiURL = process.env.VUE_APP_URL_API_BASE + '/color/list'

          return new Promise(async (resolve, reject) => {
              let status = 'Success'
              await axios({
                  url: apiURL,
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  data: {},
                  responseType: 'json'
              }).then((response) => {
                  if (response.data) {
                      self.dataColorCombo = []
                      self.dataColorCombo = response.data


                      status = 'Success'
                  }
              })
              resolve(status)
          })
      },
      getListSize() {
          let self = this

          let apiURL = process.env.VUE_APP_URL_API_BASE + '/size/list'

          return new Promise(async (resolve, reject) => {
              let status = 'Success'
              await axios({
                  url: apiURL,
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  data: {},
                  responseType: 'json'
              }).then((response) => {
                  if (response.data) {
                      self.dataSizeCombo = []
                      self.dataSizeCombo = response.data

                      status = 'Success'
                  }
              })
              resolve(status)
          })
      },
      getListVendor() {
          let self = this

          let apiURL = process.env.VUE_APP_URL_API_BASE + '/vendor/list'

          return new Promise(async (resolve, reject) => {
              let status = 'Success'
              await axios({
                  url: apiURL,
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  data: {},
                  responseType: 'json'
              }).then((response) => {
                  if (response.data) {
                      self.dataVendorCombo = []
                      self.dataVendorCombo = response.data
                      

                      status = 'Success'
                  }
              })
              resolve(status)
          })
      },
      getProduct() {
          let self = this

          //Aplicamos los filtros
          let apiURL = this.apiBase+'/article/details-admin'
          return new Promise(async (resolve, reject) => {
              let status = 'Success'
              await axios({
                  url: apiURL,
                  method: 'POST',
                  data: { id: self.id },
                  responseType: 'json'
              }).then((response) => {
                  if (response.data) {
                      //Estos dos tienen multilenguaje
                      // Dependiendo del tab de lenguaje seleccionado, asignamos el contenido correspondiente

                     if(response.data.article.name){
                          self.nameEn = response.data.article.name.en
                          self.nameEs = response.data.article.name.es
                          self.nameFr = response.data.article.name.fr
                      }

                      if(response.data.article.description){
                          self.editorDataEn = response.data.article.description.en
                          self.editorDataEs = response.data.article.description.es
                          self.editorDataFr = response.data.article.description.fr
                      }

                      self.salePrice = response.data.article.salePrice
                      self.discount = response.data.article.discount
                      self.offerPrice = response.data.article.offerPrice
                      self.isNew = response.data.article.isNew 
                      self.active = response.data.article.active 

                      if(response.data.article.category && response.data.article.category.id){
                          self.getActiveCategoryValue([response.data.article.category.id] )
                      }
                      
                      //FALTA IMAGENES - PATH
                      /* if (response.data.article.multimedia && response.data.article.multimedia[0]) {
                          self.srcImage = response.data.article.multimedia[0].path + response.data.article.multimedia[0].name
                          self.altImage = response.data.article.multimedia[0].alt 
                      } */
                      self.multimedia = response.data.article.multimedia
                      //Ordenamos segun OrderImage
                      self.multimedia.sort((a, b) => a.orderImage - b.orderImage);

                      status = 'Success'
                  }
              })
              resolve(status)
          })
      },
      getInventoryProductGrid({ page, itemsPerPage, sortBy, search }) {
          let self = this
          this.loading = true
         
          //Aplicamos los filtros
          let apiURL = process.env.VUE_APP_URL_API_BASE + '/inventory/gridbyarticle?page=' + page + '&limit=' + itemsPerPage + '&idarticle=' + self.id 
          if(self.filterVendorGridInventory && self.filterVendorGridInventory.name){
              apiURL = apiURL + '&vendor_name=' + self.filterVendorGridInventory.name
          }
          if(self.filterColorGridInventory && self.filterColorGridInventory.name){
              apiURL = apiURL + '&color_name=' + self.filterColorGridInventory.name
          }
          if(self.filterSizeGridInventory && self.filterSizeGridInventory.name){
              apiURL = apiURL + '&size_name=' + self.filterSizeGridInventory.name
          }
          apiURL = apiURL + '&quantity=' + self.filterQuantityGridInventory 
          apiURL = apiURL + '&stock=' + self.filterStockGridInventory 
          apiURL = apiURL + '&description=' + self.filterDescriptionGridInventory
          

          //Aplicamos el orden
          if (sortBy && sortBy[0]) {
              apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
          }

          return new Promise(async (resolve, reject) => {
              let status = 'Success'
              await axios({
                  url: apiURL,
                  method: 'GET',
                  data: {},
                  responseType: 'json'
              }).then((response) => {
                  if (response.data) {

                      self.dataInventoryProductGrid = []
                      self.dataInventoryProductGrid = response.data.data

                      self.pagination.from = response.data.from
                      self.pagination.to = response.data.to
                      self.pagination.total = response.data.total
                      self.pagination.current = response.data.current_page
                      self.pagination.lastPage = response.data.last_page

                      
                      this.loading = false
                      status = 'Success'
                  }
              })
              resolve(status)
          })
      },
      openDialogUpdateGridInventory(item){
          this.dialogEditGridInventory = true

          this.updateIdInventoryArticleInventory = ''
          this.updateArticlecolorsizeidArticleInventory = ''
          this.updateVendorArticleInventory = ''
          this.updateColorArticleInventory = ''
          this.updateSizeArticleInventory = ''
          this.updateQuantityArticleInventory = ''
          this.updateStockArticleInventor = ''
          this.updateDescriptionArticleInventory = ''

          this.updateIdInventoryArticleInventory= item.id
          this.updateArticlecolorsizeidArticleInventory= item.article_color_size_id
          if(item.vendor_id)  this.updateVendorArticleInventory = { id: item.vendor_id , name: item.vendor_name}
          if(item.color_id) {
              this.updateColorArticleInventory = { id: item.color_id , name: item.color_name, hexadecimalCode: item.color_hexadecimal}
          }
          if(item.size_id) this.updateSizeArticleInventory = { id: item.size_id , name: item.size_name}
          this.updateQuantityArticleInventory = item.quantity
          this.updateStockArticleInventory = item.stock
          this.updateDescriptionArticleInventory = item.description

      },
      openDialogUpdateImageProperties(item){
          this.dialogUpdateImageProperties = true

          this.updateIdImageProperties = item.id
          this.enabledColorImageProperties = false

          this.updateColorImageProperties = ''
          if(item && item.color && item.color.id) {
              this.enabledColorImageProperties = true
              this.updateColorImageProperties = { id: item.color.id , name: item.color.name}
          }

          this.updateAltImageProperties = ''
          if(item && item.alt) {
              this.updateAltImageProperties = item.alt
          }
          
      },          
      //Copia del formulario de edicion, no estan habilitadas todas las funcionalidades, se tendran que hacer desde la edicion de un producto
      createProduct() {
          const salePrice = this.salePrice === '' || this.salePrice === null ? null : Number(this.salePrice)
          if (salePrice === null || Number.isNaN(salePrice)) {
              this.messageError = 'Error! Sale price es obligatorio y debe ser numerico.'
              this.typeOfMessage = 'error'
              setTimeout(() => (this.messageError = ''), 10000)
              return
          }

          const discount = this.discount === '' || this.discount === null ? null : Number(this.discount)
          if (this.discount !== '' && this.discount !== null && Number.isNaN(discount)) {
              this.messageError = 'Error! Discount debe ser numerico.'
              this.typeOfMessage = 'error'
              setTimeout(() => (this.messageError = ''), 10000)
              return
          }

          const offerPrice = this.offerPrice === '' || this.offerPrice === null ? null : Number(this.offerPrice)
          if (this.offerPrice !== '' && this.offerPrice !== null && Number.isNaN(offerPrice)) {
              this.messageError = 'Error! Offer price debe ser numerico.'
              this.typeOfMessage = 'error'
              setTimeout(() => (this.messageError = ''), 10000)
              return
          }

          let newObject = {
              idarticle: this.id,
              name: { en: this.nameEn, es: this.nameEs, fr: this.nameFr },                     //MultiIdioma
              description: { en: this.editorDataEn, es: this.editorDataEs, fr: this.editorDataFr },  //MultiIdioma
              saleprice: salePrice,
              isnew: this.isNew,
              active: this.active
          }

          if (discount !== null) {
              newObject.discount = discount
          }
          if (offerPrice !== null) {
              newObject.offerprice = offerPrice
          }

          if (this.selectedTreeCategoryData.length > 0) {
              newObject.category = this.selectedTreeCategoryData[0];
          }

          axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/article/create', newObject, {
              responseType: 'json' // Especifica el tipo de respuesta
          })
          .then((response) => {
              if (response.data.error) {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'error'
              } else {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'success'
              }
              setTimeout(() => (this.messageError = ''), 10000)
          })
          .catch((error) => {
              this.messageError = 'Error! El articulo no se ha creado.'
              this.typeOfMessage = 'error'
              setTimeout(() => (this.messageError = ''), 10000)
              console.error(error)
          })
      },
      async addInventoryProduct(){
          let newObject = {
              idarticle: this.id,
              useradmin: this.getUser.id,
              vendor: this.vendorInventory,
              quantity: this.quantityInventory,
              stock: this.stockInventory,
              description: this.descriptionInventory
          }

          if (this.enabledColorInventory){
              newObject.color = this.colorInventory
          }
          if (this.enabledSizeInventory){
              newObject.size = this.sizeInventory
          }
        

          await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/inventory/create', newObject, {
              responseType: 'json' // Especifica el tipo de respuesta
          })
          .then((response) => {
              if (response.data.error) {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'error'
              } else {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'success'
              }
              setTimeout(() => (this.messageError = ''), 10000)
              
          })
          .catch((error) => {
              this.messageError = 'Error! El inventario no se ha modificado.'
              this.typeOfMessage = 'error'
              setTimeout(() => (this.messageError = ''), 10000)
              console.error(error)
          }) 

          // Vuelve a cargar el grid
          const { current, itemsPerPage, sortBy, search } = this.pagination;
          await this.getInventoryProductGrid({ page: current, itemsPerPage, sortBy, search });
      },
      async updateImageOrder(){

          this.multimedia.forEach((image, index) => {
              image.orderImage = index + 1;
               // Si es la primera imagen en el orden, establecer isMain en true
              if (image.orderImage === 1) {
                  image.isMain = true;
                  image.isFrontImage = true;
              } else {
                  image.isMain = false;
                  image.isFrontImage = false;
              }
              // Si es la primera imagen en el orden, establecer isMain en true
              if (image.orderImage === 2) {
                  image.isBackImage = true;
              } else {
                  image.isBackImage = false;
              }
          });
          let newObject = {
              idarticle: this.id,
              multimedia: this.multimedia
          }
          await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/multimedia/updateorder', newObject, {
              responseType: 'json' // Especifica el tipo de respuesta
          })
          .then((response) => {
              if (response.data.error) {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'error'
              } else {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'success'
              }
              setTimeout(() => (this.messageError = ''), 10000)
              
          })
          .catch((error) => {
              this.messageError = 'Error! El inventario no se ha modificado.'
              this.typeOfMessage = 'error'
              setTimeout(() => (this.messageError = ''), 10000)
              console.error(error)
          }) 


          //Vuelve a cargar las imagenes
          this.getProduct() 
      },
      async updateImageProperties(){

          let newObject = {
              id: this.updateIdImageProperties,
              idarticle: this.id,
              alt: this.updateAltImageProperties
          }
          
          if (this.enabledColorImageProperties && this.updateColorImageProperties ){
              newObject.color = this.updateColorImageProperties
          }

          await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/multimedia/updateproperties', newObject, {
              responseType: 'json' // Especifica el tipo de respuesta
          })
          .then((response) => {
              if (response.data.error) {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'error'
              } else {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'success'
              }
              setTimeout(() => (this.messageError = ''), 10000)
              
          })
          .catch((error) => {
              this.messageError = 'Error! El inventario no se ha modificado.'
              this.typeOfMessage = 'error'
              setTimeout(() => (this.messageError = ''), 10000)
              console.error(error)
          }) 

          this.dialogUpdateImageProperties = false

          //Vuelve a cargar las imagenes
          this.getProduct() 
      },
      async updateProductInventory(){
          let newObject = {
              idinventory: this.updateIdInventoryArticleInventory,
              idarticle: this.id,
              useradmin: this.getUser.id,
              articlecolorsizeid: this.updateArticlecolorsizeidArticleInventory,
              vendor: this.updateVendorArticleInventory,
              quantity: this.updateQuantityArticleInventory,
              stock: this.updateStockArticleInventory,
              description: this.updateDescriptionArticleInventory
          }

          if (this.updateColorArticleInventory && this.updateColorArticleInventory !== ''){
              newObject.color = this.updateColorArticleInventory
          }
          if (this.updateSizeArticleInventory && this.updateSizeArticleInventory !== ''){
              newObject.size = this.updateSizeArticleInventory
          }
                  
          await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/inventory/update', newObject, {
              responseType: 'json' // Especifica el tipo de respuesta
          })
          .then((response) => {
              if (response.data.error) {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'error'
              } else {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'success'
              }
              setTimeout(() => (this.messageError = ''), 10000)
              
          })
          .catch((error) => {
              this.messageError = 'Error! El inventario no se ha modificado.'
              this.typeOfMessage = 'error'
              setTimeout(() => (this.messageError = ''), 10000)
              console.error(error)
          }) 

          this.dialogEditGridInventory = false
          // Vuelve a cargar el grid
          const { current, itemsPerPage, sortBy, search } = this.pagination;
          await this.getInventoryProductGrid({ page: current, itemsPerPage, sortBy, search });
      },
      openDialogDeleteGridInventory(item) {
          this.itemInventoryToDelete = item;
          this.dialogDeleteGridInventory = true;
      },
      async deleteProductInventory(){

          let newObject = {
              idinventory: this.itemInventoryToDelete.id
          }

          this.dialogDeleteGridInventory = false;
          this.itemInventoryToDelete = null;

          await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/inventory/delete', newObject, {
              responseType: 'json' // Especifica el tipo de respuesta
          })
          .then((response) => {
              if (response.data.error) {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'error'
              } else {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'success'
              }
              setTimeout(() => (this.messageError = ''), 10000)
          })
          .catch((error) => {
              this.messageError = 'Error! El inventario no se ha modificado.'
              this.typeOfMessage = 'error'
              setTimeout(() => (this.messageError = ''), 10000)
              console.error(error)
          }) 

          // Vuelve a cargar el grid
          const { current, itemsPerPage, sortBy, search } = this.pagination;
          await this.getInventoryProductGrid({ page: current, itemsPerPage, sortBy, search });


      },
     
      //Dropzone Functions
      dragOver(event) {
          event.preventDefault();
          this.highlightDropzone(true);
      },
      dragLeave(event) {
          event.preventDefault();
          this.highlightDropzone(false);
      },
      drop(event) {
          event.preventDefault();
          this.highlightDropzone(false);
          const fileList = event.dataTransfer.files;
          this.processFiles(fileList);
      },
      highlightDropzone(highlight) {
          const dropzone = this.$refs.fileInput.parentNode;
          dropzone.classList.toggle('highlight', highlight);
      },
      handleFileInput(event) {
          const fileList = event.target.files;
          this.processFiles(fileList);

          //useFetch para guardar en la base de datos
          // Luego limpiar files
      },
      processFiles(fileList) {
          for (let i = 0; i < fileList.length; i++) {
              const file = fileList[i];
              this.selectedImages.push(fileList[i]);
              if (file.type.match('image.*')) {
                  const reader = new FileReader();
                  reader.onload = (event) => {
                      const fileData = {
                          name: file.name,
                          url: event.target.result,
                          codi: "codificada"
                      };
                      this.multimedia.push(fileData);
                  };
                  reader.readAsDataURL(file);
              }
          }
      },
      async deleteThisImage(index, id) {
          let self = this;
          // Borramos en multimedia y en la base de datos
          self.multimedia.splice(index, 1);
          
          let newObject = {
              id: id
          }
          await axios.post(process.env.VUE_APP_URL_API_BASE + '/admin/multimedia/delete', newObject, {
              responseType: 'json' // Especifica el tipo de respuesta
          })
          .then((response) => {
              if (response.data.error) {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'error'
              } else {
                  this.messageError = response.data.message
                  this.typeOfMessage = 'success'
              }
              setTimeout(() => (this.messageError = ''), 10000)
          })
          .catch((error) => {
              this.messageError = 'Error! La imagen se ha eliminado.'
              this.typeOfMessage = 'error'
              setTimeout(() => (this.messageError = ''), 10000)
              console.error(error)
          }) 

          //Vuelve a cargar las imagenes
          this.getProduct() 

      },
      moveImage(indice, id, direction) {
          // Verificar si el índice está dentro de los límites del array
          if (indice < 0 || indice >= this.multimedia.length) {
              return;
          }

          // Si la dirección es "izquierda"
          if (direction === "left") {
              // Si el índice es 0, no se puede mover más a la izquierda
              if (indice === 0) {
                  return;
              }
              // Intercambiar el elemento con el que está a su izquierda
              [this.multimedia[indice], this.multimedia[indice - 1]] = [this.multimedia[indice - 1], this.multimedia[indice]];

              this.updateImageOrder()
          }
          // Si la dirección es "derecha"
          else if (direction === "right") {
              // Si el índice es el último, no se puede mover más a la derecha
              if (indice === this.multimedia.length - 1) {
                  return;
              }
              // Intercambiar el elemento con el que está a su derecha
              [this.multimedia[indice], this.multimedia[indice + 1]] = [this.multimedia[indice + 1], this.multimedia[indice]];

              this.updateImageOrder()
          } else {
              return;
          }
      }
  },
  async beforeMount() {
      this.id = this.$route.params.id;

      // Solo crearemos el producto, despues lo podremos editar

      //await this.getListColor();
      await this.getListCategory();
      //await this.getProduct();
      //await this.getListSize();
      //await this.getListVendor();
      

      
     // await this.getInventoryProductGrid();
     

  }
}
</script>

<style lang="scss" scoped>
.dropzone {
  border: 2px dashed #ccc;
  cursor: pointer;
}

.dropzone.highlight {
  border-color: #888;
}

.image-preview {
  width: 24%; 
  height: auto;
}

.image-name {
  display: block;
  margin-top: 5px;
}



.buttons-image-dropzone {
  position: absolute;
  right: 2px;
  width: 25px;
  border: 1px solid gray;
  background: white;
  padding: 3px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;

  &.isMainImage-button {
      top: 2px;
      left: 2px;
      background: green;
  }

  &.isBackImage-button {
      top: 2px;
      left: 2px;
      background: red;
  }

  &.left-button {
      top: 29px;
      &:hover {
          background: gray;
          color: white;
      }
  }

  &.right-button {
      top: 56px;
      &:hover {
          background: gray;
          color: white;
      }
  }

  &.edit-image-button {
      top: 83px;
      &:hover {
          background: gray;
          color: white;
          
      }
  }

  &.delete-button {
      top: 2px;

      &:hover {
          background: red;
          border: 1px solid red;
          color: white;
      }
  }
}
</style>
